<template>
    <transition name="slide-fade" >
        <div>
           <ecard></ecard>
            <contactform></contactform>
            <div>
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet ">Find Us</h3><br>
                </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6305.656915691685!2d-81.3838487527334!3d19.293572642113443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f25865e3b5d45a7%3A0x19d33bfa80e61ef6!2sElizabethan%20Square!5e1!3m2!1sen!2sjm!4v1696811077514!5m2!1sen!2sjm" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    </transition>
</template>

<script>
    import ecard from "../components/sections/contactus/ecard";
    import contactform from "../components/sections/contactus/contactForm";

    export default {
        name: "contactUs",
      metaInfo: {
        title: ' Contact Us ',
        meta: [{
          content: 'At FINCOR we are always waiting to hear from you and are ready to assist you in any financial situation. Call us today at 1345-746-9272 (345-74MYCPA) or email us at admin@fincor.ky'
        }]
      },
        components: {
            ecard,
            contactform
        }
    }
</script>

<style scoped>

</style>